export namespace Videos {
  export enum Pages {
    VIDEOS ='videos',
    VIDEO_DETAIL = 'video',
  }

  export type Video = {
    id?: string | number,
    url: string,
    image: string,
    duration: string,
  }
}
